import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import deleteContactIcon from "../assets/deleteContactIcon.svg"
import Cardproductor from "./CardProductor"
import DetailProductor from "./DetailProductor"
import test from "../../Pages/assets/Animacion-nosotros.webm"
import iconAddSeguimiento from "./iconAddSeguimiento.svg"
import { getAllsProductores, getProductorById, createProductor, getReporteActividadAsesor } from "../../endpoints"
import { useParams } from "react-router-dom";
import CustomCircularProgress from "../../Components/Loading/CustomCircularProgress"
import ModalCreateProductor from "../../Components/Productores/ModalCreateProductor"

const Productores = ({ user }) => {
  const [loading, setLoading] = useState(false);
  const [modalCreateProductor, setModalCreateProductor] = useState(false);
  const [productores, setProductores] = useState([]);
  const [selectedProductor, setselectedProductor] = useState(null);
  const [productoresTotales, setProductoresTotales] = useState(0);
  const params = useParams();
  useEffect(() => {
    if (params.id) {
      console.log(params.id, "HOLA")
      setLoading(true)
      getProductorID(params.id)
    }
    console.log(params.id, "HOLA")
  }, [params]);


  const getProductorID = (id) => {
    getProductorById(id).then((res) => {
      if (res?.status === 200) {
        console.log(res.data)
        setselectedProductor(res.data)
        // Adding a delay of 2 seconds
        setTimeout(() => {
          setLoading(false);
        }, 500);
      } else {
        console.log(res)
        setLoading(false)

      }
    })
  }

  const openModalCreateProductor = () => {
    setModalCreateProductor(true);
  }
  const closeModalCreateProductor = () => {
    setModalCreateProductor(false);
  }
  const handleFormClick = (e) => {
    e.stopPropagation(); // Evita que el evento de clic se propague hacia arriba
  };

  const obtenerProductores = async () => {
    getAllsProductores(
      {
        page: 1,
        perPage: 35,
      }
    ).then((res) => {
      if (res.status === 200) {
        console.log(res.data, "DATA")
        setProductores(res.data.productores)
        setProductoresTotales(res.data.productores.length)
      } else {
        console.log(res)
      }
    })
  }

  useEffect(() => {
    obtenerProductores()
  }, [])

  useEffect(() => {
    console.log(productores)
  }, [productores])

  return (
    <ContainerBox>

      <DivContentFilters>
        <DivRow>
          <DivColumn1>
            <Text1>{`Total: ${productoresTotales}`}</Text1>
          </DivColumn1>

          <DivRow1>
            <ButtonCreateProductor onClick={openModalCreateProductor}>
              <ActionBtn
                src={iconAddSeguimiento} />
              Crear Productor
            </ButtonCreateProductor>
            <ButtonCreateProductor
              disable={!selectedProductor && !selectedProductor?.name ? true : false}
              style={{
                opacity: !selectedProductor && !selectedProductor?.name ? 0.1 : 1
              }}
            >
              Eliminar
              <ActionBtn
                src={deleteContactIcon}
              />
            </ButtonCreateProductor>
          </DivRow1>
        </DivRow>
        <Input
          type="text"
          placeholder="Buscar..."
        // value={searchTerm}
        />

        <ScrollContainer>
          {productores && productores.length < 1 ? (
            <Text style={{ textAlign: 'center' }}>No se encontraron resultados.</Text>
          ) : (
            <>
              {productores.map((productor, index) => (
                <Cardproductor
                  key={productor.id}
                  productor={productor}
                  setselectedProductor={setselectedProductor}
                  selectedProductor={selectedProductor}
                />
              ))}
            </>
          )}
        </ScrollContainer>
      </DivContentFilters>
      <DivFlexColumn>

        {
          loading === false && selectedProductor?.id !== undefined ? (
            <DetailProductor
              selectedProductor={selectedProductor}
              user={user}
              getReporteActividadAsesor={getReporteActividadAsesor}
            />
          ) : loading === false && !selectedProductor?.id ? (
            <VideoCont src={test}

              autoPlay
              //  controls 
              loop
            ></VideoCont>
          ) : (
            <CustomCircularProgress size={50} padding='15vw' />
          )
        }
      </DivFlexColumn>
      {
        modalCreateProductor ?
          <ModalCreateProductor
            closeModalCreateProductor={closeModalCreateProductor}
            createProductor={createProductor}
            stopPropagation={handleFormClick}
            obtenerProductores={obtenerProductores}
          /> : null
      }

    </ContainerBox>
  )
}

export default Productores

const ButtonCreateProductor = styled.button`
  border-color: #dadce0;
  box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
  cursor: pointer;
  margin: 0px 0px 0px 0px;
  align-self: end;
  gap: 8px;
  font-family: 'Montserrat',sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #07082c;
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px;
  height: auto;
  border-radius: 8px;
  width: auto;
  min-width: max-content;
  border:none;
  background: none !important;
  &:focus {
    outline: none;
  }
  &:hover {
    transition: all 0.1s linear;
    filter: opacity(0.5);
    box-shadow: rgba(0, 0, 0, .2) 0 1px 1px;
  }
  &:active {
    transform:scale(0.90)
  }
`;

const VideoCont = styled.video`
  border-radius: 8px;
  height: auto;
  width: 50%;
  margin: 15%;
`;


const DivContentFilters = styled.div`
  width: 25vw;
  min-width:280px;
  max-width: 350px;
  height: auto;
  min-height: 98vh!important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0px;
  padding: 0px 0px 8px 24px;
  background-color: #FFFFFF;

`;

const DivFlexColumn = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  width: -webkit-fill-available;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  max-height: 85vh;
  min-height: 85vh;
  overflow-y: auto;
  border-radius: 8px;
  margin-right: 16px;
  margin-top: 8px;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;

const ActionBtn = styled.img`
  max-width:20px;
  max-height:20px;
  width:20px;
  height:20px;
  cursor:pointer;
  &:active{
    zoom: 95%;
  }
`;


const Input = styled.input`
  box-shadow: rgb(0 0 0 / 6%) 0px 2px 4px 0px inset;
  width: -webkit-fill-available;
  min-width: -webkit-fill-available;
  margin: 8px 8px;
  padding:5px;
  border:none;
  outline: none;
  background:#FFFFFF;
  border-radius:8px;
  height:26px;
  min-height:26px;
  max-width: 10vw;
  font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #07082c;
  &:placeholder{
    font-family: 'Montserrat', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #07082c;
  }
`;

const ContainerBox = styled.div`
  width: -webkit-fill-available;
  height: auto;
  min-height: 95vh;
  max-height: 95vh;
  overflow-y: hidden;
  max-width: calc(100vw - 84px);
  gap: 16px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 1% 16px 0px 1%;
  background-color:#FFFFFF;
  border-radius:8px;
  box-shadow: 0px 1.5px 2px 0px rgba(16, 24, 40, 0.10);
  border: 1px solid var(--Neutral-Gray-Gray-100, #E0E2E7);
`;

const DivRow = styled.div`
  width: -webkit-fill-available;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 0.5em 0.5em 0.5em;
  justify-content: space-between;
`;

const DivColumn1 = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;

const DivRow1 = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 5px;
`;

const ScrollContainer = styled.div`
  width: -webkit-fill-available;
  height: auto;
  max-height: calc(100vh - 31vh) !important;
  overflow-y: auto;
  overflow-x: hidden;
  gap: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0%;
  scroll-behavior: smooth;
  padding: 8px 0px 0px 0px;
  border-top: 2px solid #003049;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    height: 4px;
    width: 3px;
    background-color: transparent !important;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #003049 !important;
    border-radius: 8px;
  }

`;

const Text = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #003049;
`;
const Text1 = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #003049;
`;
